
export default function LocationMap() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Visit Our Office</h2>
          <p className="text-xl text-gray-600">
            Located in Talladega, Alabama - Your gateway to glamping retreat investments
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3326.8!2d-86.1058!3d33.4734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x888925c5c5c5c5c5%3A0x1234567890abcdef!2s1591%20Allison%20Mill%20Rd%2C%20Talladega%2C%20AL%2035160!5e0!3m2!1sen!2sus!4v1234567890"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="OED Tiny Homes Office Location - 1591 Allison Mill Rd, Talladega, AL 35160"
          ></iframe>
        </div>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-car-line text-xl text-emerald-600"></i>
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Parking</h3>
            <p className="text-gray-600 text-sm">Free parking available on-site</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-line text-xl text-emerald-600"></i>
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Easy Access</h3>
            <p className="text-gray-600 text-sm">Convenient location off Allison Mill Road</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-line text-xl text-emerald-600"></i>
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Appointments</h3>
            <p className="text-gray-600 text-sm">Schedule a visit to discuss your project in person</p>
          </div>
        </div>
      </div>
    </section>
  );
}
